module.exports = __webpack_public_path__ + "static/media/tech2.39882619.svg";